import React from 'react';
import useFleetStore from '../../stores/useFleetStore';
import Panel from '../../components/ui/Panel';

const FleetHealthModule = () => {
  const drones = useFleetStore((state) => state.drones);
  const flags = useFleetStore((state) => state.flags);

  const total = drones.length;
  const flagged = flags.length;
  const available = total - flagged;
  const healthPct = total > 0 ? Math.round((available / total) * 100) : 0;

  const color = healthPct >= 90 ? 'text-green-400' : healthPct >= 70 ? 'text-yellow-400' : 'text-red-400';
  const ringColor = healthPct >= 90 ? 'stroke-green-400' : healthPct >= 70 ? 'stroke-yellow-400' : 'stroke-red-400';
  const accent = healthPct >= 90 ? 'green' : healthPct >= 70 ? 'yellow' : 'red';

  const circumference = 2 * Math.PI * 40;
  const dashOffset = circumference - (healthPct / 100) * circumference;

  return (
    <Panel label="Fleet health" accent={accent} lit>
      <div className="flex items-center gap-4">
        {/* Compact circular gauge */}
        <div className="relative flex-shrink-0">
          <svg width="88" height="88" viewBox="0 0 88 88">
            <circle cx="44" cy="44" r="40" fill="none" stroke="currentColor"
                    className="text-outline-variant" strokeWidth="5" />
            <circle cx="44" cy="44" r="40" fill="none"
                    className={ringColor} strokeWidth="5"
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={dashOffset}
                    transform="rotate(-90 44 44)"
                    style={{ transition: 'stroke-dashoffset 1s ease-out' }} />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className={`text-xl font-bold ${color} tabular-nums`}>{healthPct}%</span>
          </div>
        </div>

        {/* Compact stats */}
        <div className="space-y-1.5 flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <span className="text-[11px] text-on-surface-variant">Total</span>
            <span className="text-sm font-semibold text-on-surface tabular-nums">{total}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-[11px] text-on-surface-variant">Ready</span>
            <span className="text-sm font-semibold text-green-400 tabular-nums">{available}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-[11px] text-on-surface-variant">Flagged</span>
            <span className={`text-sm font-semibold tabular-nums ${flagged > 0 ? 'text-orange-400' : 'text-on-surface-disabled'}`}>{flagged}</span>
          </div>
        </div>
      </div>
    </Panel>
  );
};

export default FleetHealthModule;
